import { RootState } from 'editor/src/store/index';

import getSpreadPage from './getSpreadPage';

const getSpreadPageMediaElements = (state: RootState, spreadIndex: number, pageIndex: number) =>
  getSpreadPage(state, spreadIndex, pageIndex)?.groups.media;

export default getSpreadPageMediaElements;
